import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LbdModule } from './lbd/lbd.module';

import { RouteService } from './services/route.service';
import { StatusMonitorService } from './services/status-monitor.service';
import { StatusHistoryService } from './services/status-history.service';
import { MainRoutingModule } from './main.routing';
import { LayoutComponent } from './layout/layout.component';
import { StatusComponent } from './status/status.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HistoryComponent } from './history/history.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HistoryPageComponent } from './history-page/history-page.component';

@NgModule({
  imports: [
    CommonModule,
    MainRoutingModule,
    HttpClientModule,
    LbdModule
  ],
  declarations: [
    LayoutComponent,
    StatusComponent,
    SidebarComponent,
    NavbarComponent,
    HistoryComponent,
    NotFoundComponent,
    HistoryPageComponent
  ],
  providers: [
    RouteService,
    StatusMonitorService,
    StatusHistoryService
  ]
})
export class MainModule { }



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/main.module.ts